






import { Component, Vue, Watch } from "vue-property-decorator";
import IssueInProcess from "_C/main/Finish/IssueInProcess.vue";
import IssueSuccess from "_C/main/Finish/IssueSuccess.vue";
import IssueOther from "_C/main/Finish/IssueOther.vue";
import BadEnd from "_C/main/Finish/BadEnd.vue";
import { InsuranceCard } from "@/services/index.defs";
import { CalcStatus, CalcState } from "@/models/Models";
import { GaHelper } from "@/core/helpers/ga";
import { isSameDay } from "date-fns";

@Component({
    components: { BadEnd, IssueOther, IssueSuccess, IssueInProcess }
})
export default class Finish extends Vue {
    isDev = process.env.NODE_ENV == "development";
    get useComponent() {
        if (this.success)
            return IssueSuccess;

        if (this.loading)
            return IssueInProcess;

        if (this.tryAnother)
            return IssueOther;

        return BadEnd;
    }
    get issue(): CalcState {
        return this.$store.direct.state.iccalc.calcStates.find(
            x => x.insuranceProviderId == this.currentCalc?.insuranceProviderId
        );
    }
    get isFastCalcDisabled() {
        return this.$store.direct.getters.isFastCalcDisabled;
    }
    get calcStates(): any[] {
        return this.$store.direct.state.iccalc.calcStates;
    }
    get currentCalc() {
        return this.$store.direct.state.iccalc.currentCalc;
    }
    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }
    statsSent = false;
    @Watch("calcStates") sendOtherExistStat() {
        if (
            ![CalcStatus.CalcFail, CalcStatus.NeedToSelectCar].includes(
                this.issue?.status
            ) ||
            this.statsSent
        )
            return;
        const states = this.$store.direct.state.iccalc.calcStates;
        const issued = x => x.status == CalcStatus.Issued;
        const anyIssued = states.some(issued);
        if (anyIssued) {
            this.statsSent = true;
            GaHelper.send("issue/otherExist");
        }
    }
    // same conditions
    get isSameCond() {
        const isSamePrice = this.currentCalc?.amount == this.issue?.amount;
        const isSameMonth =
            this.card.insuranceMonth == this.currentCalc?.month &&
            this.card.insuranceMonth == this.issue?.month;
        const isSameDate =
            isSameDay(
                this.currentCalc?.beginDate?.parseDate(),
                this.card.beginDate.parseDate()
            ) &&
            isSameDay(
                this.issue.beginDate.parseDate(),
                this.card.beginDate.parseDate()
            );
        return isSamePrice && isSameDate && isSameMonth;
    }
    // Успешный calc и issue
    get issueSuccess() {
        return this.issue?.status == CalcStatus.Issued;
    }
    get paylinkUsed() {
        return this.$store.direct.state.insurance.paylinkUsed;
    }
    // Если расчёт успешен, то поздравляю
    get success() {
        return (this.issueSuccess && this.isSameCond)
            || this.paylinkUsed
            || (this.isFastCalcDisabled && this.currentCalc?.insuranceProviderId);
    }
    get loading() {
        if (this.isFastCalcDisabled)
            return false;
        // const issueSuccess = this.issueSuccess;
        const timeIsUp = this.$store.direct.state.iccalc.buyTime < 1;
        const forceEnd = this.$store.direct.state.iccalc.forceEnd;
        const issueFail = [
            CalcStatus.CalcFail,
            CalcStatus.NeedToSelectCar
        ].includes(this.issue?.status);
        // const calcExist = this.calcStates.includes(
        //     x => x.insuranceProviderId == this.currentCalc.insuranceProviderId
        // );
        if (issueFail) return false; // Если issue == fail, то убираем загрузку, показываем другие предложения
        return !this.issueSuccess && !timeIsUp && !forceEnd; // Если final calc != fail, то ждём результат issue
    }
    get tryAnother() {
        const iccalc = this.$store.direct.state.iccalc;
        const currentProvId = iccalc.currentCalc?.insuranceProviderId;
        const byNotCurrent = x => x.insuranceProviderId != currentProvId;
        const states = this.calcStates.filter(byNotCurrent); // убрать выбранную из списка предложений
        const failed = x =>
            [CalcStatus.CalcFail, CalcStatus.NeedToSelectCar].includes(
                x?.status
            );
        const allFailed = states.every(failed);
        const issueFail = [
            CalcStatus.CalcFail,
            CalcStatus.NeedToSelectCar
        ].includes(this.issue?.status);
        const timeIsUp = this.$store.direct.state.iccalc.buyTime < 1;
        if (allFailed && issueFail) return false;
        // если нет предложений не показывать экран с предложениями
        else if (this.isFastCalcDisabled /* быстрый расчет выключен */ ) {
            return states.some(x => !failed(x)); // есть положительные ответы либо идет загрузка
        }
        else if (
            timeIsUp && //таймер закончился
            !states.some(x => x.status == CalcStatus.Issued) && //и дополнительные расчеты не имеют положительных ответов
            this.issue?.status != CalcStatus.Issued // и основной расчет не положительный
        )
            return false;
        return (
            (this.issueSuccess && !this.isSameCond) || // если условия изменились
            issueFail || // если расчёт пофейлился и не все предложения пофейлились
            timeIsUp // если кончилось время
        );
    }
    created() {
        this.$store.direct.dispatch.iccalc.pollCardIssuing(this.card);
    }
    destroyed() {
        this.$store.direct.commit.iccalc.disposeChecker();
    }
}
